/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CloseAction/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import Shortcut from 'DesignSystem/Shortcut/react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonIcon from 'DesignSystem/TysiaButton/TysiaButtonIcon/index'
import TysiaIconClose from 'DesignSystem/Svgs/TysiaIconClose/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function CloseAction({
  children,
  viewPath = "/DesignSystem/GenerateLettersModal/Content/Letters/Letter/Actions/EditLetterAction/Comms/Content/CloseAction",
  isHovered
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath,
  isHovered
  
})
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let onPress = fromHelpers.useOnClick({
  children,
  viewPath,
  isHovered
  
})
  return (<React.Fragment
>
<div
  data-testid="CloseAction.Vertical"
  data-view-path={viewPath}
 style={{'--r-1-1xAYKG': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="ghost"
 size="small"
 onClick={onClick}
>
{childProps => (
<TysiaButtonIcon
{...childProps}
  viewPath={`${viewPath}/TysiaButtonIcon`}
>
{childProps => (
<TysiaIconClose
{...childProps}
  viewPath={`${viewPath}/TysiaIconClose`}
 fill={childProps.isHovered ? dtColorsNeutral500 : dtColorsNeutral400}
/>
)}
</TysiaButtonIcon>
)}
</TysiaButton>
<Shortcut
  viewPath={`${viewPath}/Shortcut`}
 keys="escape"
 onPress={onPress}
/>
</div>
{children}
</React.Fragment>)
}